<template>
  <section class="success-stories" :style="containerStyle">
    <div>
      <v-tabs v-model="tab" :change="changeTab(tab)"
              next-icon="mdi-arrow-right-bold-box-outline"
              prev-icon="mdi-arrow-left-bold-box-outline"
              show-arrows
              ref="tabsContainer">
        <v-tabs-slider></v-tabs-slider>
        <v-tab v-for="item in items">
          <div class="tab__label">
            {{ item.label }}
          </div>
          <div class="tab__label_sm">
            {{ item.label_sm }}
          </div>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item v-for="item in items">
          <v-card flat>
            <div class="success-stories__content">
              <div class="success-stories__img">
                <img :src="item.src" alt="">
              </div>
              <div class="success-stories__descr d-flex flex-column">
                <div class="success-stories__title">{{ item.label }}</div>
                <div class="success-stories__title_sm">{{ item.label_sm }}</div>
                <div class="success-stories__text" v-html="item.descr"></div>

                <a class="success-stories__btn btn-red " :href="item.url">Подробнее</a>
              </div>

            </div>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    stories: Array | String | Number | Boolean | Object,
  },
  name: "SuccessStories",
  data() {
    return {
      tab: null,
      /*items: [
        {
          label: "Кирилл Усачев",
          label_sm: "Выпускник первой волны Лидерской программы",
          src: "/upload/transport.jpg",
          descr: "Мы крупнейших производитель и дистрибьютор транспортной упаковки. Инвестиции в развитие высокотехнологичной упаковки позволяют бизнесу предлагать лучшие решения для транспортировки грузов.",
          url: "#",

        },
        {
          label: "Кирилл Усачев",
          label_sm: "Выпускник первой волны Лидерской программы",
          src: "/upload/transport.jpg",
          descr: "Мы крупнейших производитель и дистрибьютор транспортной упаковки. Инвестиции в развитие высокотехнологичной упаковки позволяют бизнесу предлагать лучшие решения для транспортировки грузов.",
          url: "#",

        },
        {
          label: "Кирилл Усачев",
          label_sm: "Выпускник первой волны Лидерской программы",
          src: "/upload/transport.jpg",
          descr: "Мы крупнейших производитель и дистрибьютор транспортной упаковки. Инвестиции в развитие высокотехнологичной упаковки позволяют бизнесу предлагать лучшие решения для транспортировки грузов.",
          url: "#",

        },
        // {
        //   label: "Кирилл Усачев",
        //   label_sm: "Выпускник первой волны Лидерской программы",
        //   src: "/upload/transport.jpg",
        //   descr: "Мы крупнейших производитель и дистрибьютор транспортной упаковки. Инвестиции в развитие высокотехнологичной упаковки позволяют бизнесу предлагать лучшие решения для транспортировки грузов.",
        //   url: "#",
        //
        // },

      ]*/
      items: this.stories,
      tabWidth: null,
      resizeTimeout: null,
    }
  },
  computed: {
    containerStyle() {
      // Применяем вычисленную ширину только на разрешениях >= 576px
      if (this.tabWidth && window.innerWidth >= 576) {
        return {
          '--tab-width': `${this.tabWidth}px`
        }
      }
      return {}
    }
  },
  watch: {
    tab() {
      // Пересчитываем ширину при изменении активного таба, так как может измениться видимость стрелок
      this.$nextTick(() => {
        setTimeout(() => {
          this.calculateTabWidth()
        }, 50)
      })
    }
  },
  mounted() {
    // Небольшая задержка для полного рендеринга
    setTimeout(() => {
      this.calculateTabWidth()
    }, 100)
    window.addEventListener('resize', this.handleResize)
  },
  updated() {
    this.$nextTick(() => {
      this.calculateTabWidth()
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout)
    }
  },
  methods: {
    changeTab(item) {
      console.log("changeTab")
    },
    handleResize() {
      // Debounce для resize
      clearTimeout(this.resizeTimeout)
      this.resizeTimeout = setTimeout(() => {
        this.calculateTabWidth()
      }, 100)
    },
    calculateTabWidth() {
      this.$nextTick(() => {
        const windowWidth = window.innerWidth

        // Определяем количество табов в зависимости от разрешения
        let tabsCount = 1
        if (windowWidth >= 992) {
          tabsCount = 3
        } else if (windowWidth >= 576) {
          tabsCount = 2
        } else {
          // Ниже 576px не вычисляем ширину, используем стандартные стили
          this.tabWidth = null
          return
        }

        const tabsElement = this.$refs.tabsContainer?.$el
        if (!tabsElement) {
          setTimeout(() => this.calculateTabWidth(), 100)
          return
        }

        // Берем сам элемент .v-tabs для получения видимой ширины
        // Или используем родительский контейнер, если .v-tabs не имеет фиксированной ширины
        let containerWidth = 0

        // Пробуем получить ширину из самого .v-tabs элемента
        const tabsRect = tabsElement.getBoundingClientRect()
        if (tabsRect.width > 0 && tabsRect.width < 10000) {
          containerWidth = tabsRect.width
        } else {
          // Если не получилось, используем родительский контейнер
          const parent = tabsElement.parentElement
          if (parent) {
            const parentRect = parent.getBoundingClientRect()
            containerWidth = parentRect.width
          }
        }

        if (!containerWidth || containerWidth === 0 || containerWidth > 10000) {
          setTimeout(() => this.calculateTabWidth(), 100)
          return
        }

        // Проверяем наличие и видимость стрелок навигации
        const prevArrow = tabsElement.querySelector('.v-slide-group__prev')
        const nextArrow = tabsElement.querySelector('.v-slide-group__next')

        // Ширина каждой стрелки 33px
        const arrowWidth = 33
        let arrowsWidth = 0

        // Проверяем, видна ли стрелка "назад"
        // Стрелка видна, если она существует, не скрыта через display:none, имеет offsetWidth > 0
        // и не имеет класса disabled или скрыта через классы Vuetify
        if (prevArrow) {
          const computedStyle = window.getComputedStyle(prevArrow)
          const isVisible = computedStyle.display !== 'none' &&
              computedStyle.visibility !== 'hidden' &&
              prevArrow.offsetWidth > 0 &&
              prevArrow.offsetHeight > 0

          // Также проверяем, что стрелка не disabled (может быть скрыта через классы Vuetify)
          const isNotDisabled = !prevArrow.classList.contains('v-slide-group__prev--disabled')

          if (isVisible && isNotDisabled) {
            arrowsWidth += arrowWidth
          }
        }

        // Проверяем, видна ли стрелка "вперед"
        if (nextArrow) {
          const computedStyle = window.getComputedStyle(nextArrow)
          const isVisible = computedStyle.display !== 'none' &&
              computedStyle.visibility !== 'hidden' &&
              nextArrow.offsetWidth > 0 &&
              nextArrow.offsetHeight > 0

          const isNotDisabled = !nextArrow.classList.contains('v-slide-group__next--disabled')

          if (isVisible && isNotDisabled) {
            arrowsWidth += arrowWidth
          }
        }

        // margin: 5px означает 5px с каждой стороны, между двумя табами будет 10px (5px + 5px)
        const marginBetweenTabs = 10
        const totalMargins = marginBetweenTabs * (tabsCount - 1) // Для 3 табов: 20px, для 2 табов: 10px

        // Вычисляем ширину одной вкладки: (ширина контейнера - стрелки - все отступы) / количество вкладок
        const availableWidth = containerWidth - arrowsWidth
        const calculatedWidth = (availableWidth - totalMargins) / tabsCount

        if (calculatedWidth > 0 && calculatedWidth < 10000) { // Защита от слишком больших значений
          this.tabWidth = Math.floor(calculatedWidth)
          console.log('Tab width calculated:', this.tabWidth, 'Tabs count:', tabsCount, 'Container width:', containerWidth, 'Arrows width:', arrowsWidth, 'Available width:', availableWidth, 'Margins:', totalMargins)
        }
      })
    },
  }
}
</script>


<style scoped lang="scss">

.success-stories {

  &__content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;

    @media (max-width: 1400px) {
      grid-template-columns: 1fr;
    }
  }

  &__descr {
    background: #F5F5F7;
    border-radius: 40px;
    padding: 48px;


    @media (max-width: 766px) {
      width: 100%;
      min-height: 238px;
    }

    @media (max-width: 425px) {
      padding: 20px;
    }
  }

  &__title {
    font-family: 'MuseoSansCyrl-500';
    font-weight: 400;
    font-size: 52px;
    line-height: 72px;
    letter-spacing: -2.24px;
    color: #212424;
    margin-bottom: 32px;


    @media (max-width: 1600px) {
      font-size: 50px;
      line-height: 62px;
    }

    @media (max-width: 768px) {
      font-size: 44px;
      line-height: 56px;
    }

    @media (max-width: 500px) {
      font-size: 34px;
      line-height: 46px;
    }
  }

  &__title_sm {


    color: #4F4D55;
    font-family: "RobotoRegular";
    font-weight: 400;
    font-size: 24px;
    leading-trim: NONE;
    line-height: 28px;
    letter-spacing: 0%;
    vertical-align: middle;
    margin-bottom: 48px;

    @media (max-width: 1600px) {
      font-size: 20px;
      line-height: 20px;
    }

    @media (max-width: 768px) {
      font-size: 17px;
      line-height: 20px;
    }

    @media (max-width: 500px) {
      font-size: 13px;
      line-height: 20px;
    }
  }




  &__img {

    & img {
      border-radius: 40px;
      width: 100%;
      max-width: 100%;
      max-height: 588px;
      object-fit: cover;

      @media (max-width: 1400px) {
        max-width: unset;
        object-fit: cover;
        height: auto;
      }

    }
  }

  &__btn {
    max-width: max-content;
  }


}
</style>

<style lang="scss">
.success-stories {
  &__text {
    margin-bottom: 48px;
  }
  &__text p,
  &__text {
    font-family: "RobotoRegular";
    font-weight: 400;
    font-size: 22px;
    line-height: 30px;
    letter-spacing: 0px;
    color: #212424;

    flex-grow: 1;

    @media (max-width: 1600px) {
      font-size: 22px;
      line-height: 30px;
    }

    @media (max-width: 768px) {
      font-size: 20px;
      line-height: 26px;
    }

    @media (max-width: 500px) {
      font-size: 16px;
      line-height: 22px;
    }
  }
}
.success-stories {
  & .v-slide-group__next--disabled,
  & .v-slide-group__prev--disabled {
    display: none;
  }
  .v-tab:not(.v-tab--active) {
    & svg {
      display: none;
    }
  }

  .v-ripple__container {
    display: none;
  }

  & .v-tabs-slider {
    height: 0;
  }

  .v-tabs:not(.v-tabs--vertical):not(.v-tabs--right) > .v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-slide-group--has-affixes) .v-slide-group__prev {
    display: none;

  }

  .v-tabs {
    @media (max-width: 766px) {
      max-width: 91vw;
    }
  }

  & .v-tab {
    gap: 14px;
    margin: 5px;
    border: 1px solid #E4E4E4;
    background: #FFFFFF;
    border-radius: 40px;
    padding: 12px 24px;
    height: 150px;
    flex-direction: column;
    transition: all 0.2s ease;

    &:hover{
      border-color: #4F4D55;
    }

    // Для разрешения >= 992px: 3 таба
    @media (min-width: 992px) {
      width: var(--tab-width, 587px) !important;
      min-width: var(--tab-width, unset) !important;
      max-width: var(--tab-width, unset) !important;
      flex-shrink: 0;
      flex-grow: 0;
    }

    // Для разрешения >= 576px и < 992px: 2 таба
    @media (min-width: 576px) and (max-width: 991px) {
      width: var(--tab-width, 587px) !important;
      min-width: var(--tab-width, unset) !important;
      max-width: var(--tab-width, unset) !important;
      flex-shrink: 0;
      flex-grow: 0;
    }

    // Для разрешения < 576px: 1 таб (стандартные стили)
    @media (max-width: 575px) {
      width: 276px;
      min-width: unset;
      max-width: 276px;
    }

    @media (min-width: 576px) and (max-width: 1200px) {
      padding: 10px 15px;
    }

    @media (max-width: 375px) {
      height: 70px;
    }

    &:before {
      background-color: transparent !important;
    }

    & > .tab__label {
      color: #212424;
      text-transform: none;
      font-family: "MuseoSansCyrl-600";
      font-size: 32px;
      leading-trim: NONE;
      line-height: 40px;
      letter-spacing: 0px;
      vertical-align: middle;
      @media (max-width: 1500px) {
        font-size: 28px;
        leading-trim: NONE;
        line-height: 25px;
      }
      @media (max-width: 576px) {
        font-size: 22px;
        leading-trim: NONE;
        line-height: 20px;
      }
    }

    & > .tab__label_sm {
      color: #4F4D55;
      font-family: "RobotoRegular";
      font-weight: 400;
      font-size: 20px;
      leading-trim: NONE;
      line-height: 26px;
      letter-spacing: 0px;
      text-align: center;
      vertical-align: middle;
      text-transform: none;
      //max-width: 480px;

      @media (max-width: 1500px) {
        font-size: 20px;
        leading-trim: NONE;
        line-height: 20px;
      }
      @media (max-width: 576px) {
        font-size: 16px;
        leading-trim: NONE;
        line-height: 20px;
      }

      @media (max-width: 375px) {
        display: none;
      }

    }

    &--active {
      outline: none;
      border: 1px solid #F94237;

      .tab__label {
        color: #F94237;
      }

      &:before {
        background-color: transparent !important;
      }

      & > span {
        color: #F94237 !important;
      }
    }

  }

  .v-slide-group {
    &__content {
      //gap: 10px;
    }
  }

  .v-tabs-bar {
    height: 160px;

    @media (max-width: 375px) {
      height: 70px;
    }
  }

  .v-item-group {
    margin-top: 40px;


    &.v-tabs-items {
      border-bottom-left-radius: 20px;
      border-top-left-radius: 20px;
      box-shadow: 0px 4px 4px 0px #00000005;

      @media (max-width: 766px) {
        border-bottom-left-radius: 0;
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
      }
    }

    .theme--light.v-card {
      background-color: transparent;
    }

  }

  .v-item-group.v-tabs-items {
    box-shadow: none !important;
  }

  .v-slide-group__wrapper {
    height: 165px;
  }

  .v-tab.v-tab:hover {
    opacity: 1 !important;
  }

  & .v-tabs-bar,
  & .theme--light.v-tabs-items {
    background-color: transparent !important;
  }

  .v-slide-group:not(.v-slide-group--has-affixes) > .v-slide-group__prev, .v-slide-group:not(.v-slide-group--has-affixes) > .v-slide-group__next {
    display: none;
  }

  .mdi-arrow-right-bold-box-outline::before {
    content: '';
    background: url("/upload/chevron-right.svg") no-repeat;
    background-size: contain;
    width: 40px;
    height: 40px;
  }

  .mdi-arrow-left-bold-box-outline::before {
    content: '';
    background: url("/upload/chevron-right.svg") no-repeat;
    background-size: contain;
    width: 40px;
    height: 40px;
    rotate: 180deg;
  }

  .v-slide-group__next, .v-slide-group__prev {
    min-width: 33px;
  }

}


</style>